import Computer from 'mbs-ui-shared@models/Computer';
import { StorageConnection } from 'mbs-ui-shared@models/storge-connections';
import { RestorePointItem, RestoreType } from 'wizards/models/restore-point-models';
import { PlanForRestore } from 'wizards/services/wizard-steps.service';

export enum RestoreToVariants {
  current = 0,
  original = 1,
  different = 2
}

export type FromToStepData = { restoreTo: RestoreToVariants; fromComputer: Computer; toComputer: Computer };

export type WhatToStepData = {
  destination: StorageConnection;
  plan: PlanForRestore;
  point: RestorePointItem;
  pointType: RestoreType;
  password?: string;
};

export type GenericRestoreData = {
  fromToStepData: FromToStepData;
  whatToStepData: WhatToStepData;
};
